import { render, staticRenderFns } from "./UserC1View.vue?vue&type=template&id=2968afba&"
import script from "./UserC1View.vue?vue&type=script&lang=js&"
export * from "./UserC1View.vue?vue&type=script&lang=js&"
import style0 from "./UserC1View.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports